import { gql } from '@apollo/client';

// export const CREATE_EPISODE = gql`
//     mutation CreateEpisode($input:CreateEpisodeInput!) {
//     createEpisode(input: $input) {
//         data {
//             video_episode {
//                 id
//                 label
//                 season_id
//                 episode_number
//             }
//         }
//         error {
//             message
//         }
//     }
// }

// `;
export const CREATE_EPISODE = gql`
  mutation CreateEpisode($input:CreateEpisodeInput!) {
    createEpisode(input: $input) {
        data {
            video_episode {
                created_at
                episode_number
                id
                label
                season_id
                series_id
                updated_at
            }
        }
        error {
            code
            field
            message
        }
    }
}


`;
export const UPDATE_EPISODE = gql`
    mutation UpdateEpisode($input:UpdateEpisodeInput!) {
    updateEpisode(input: $input) {
        data {
            video_episode {
                id
                label
                season_id
                episode_number
            }
        }
        error {
            message
        }
    }
}

`;
export const DELETE_EPISODE = gql`
  mutation DeleteEpisode($episode_id:UUID,$folder_id: String) {
    deleteEpisode(episode_id: $episode_id, folder_id: $folder_id) {
        error {
            message
        }
        data {
            message
        }
    }
}

`;